var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32CircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    stroke: "#0A7E85",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11.25,
    r: 1.25,
    transform: "rotate(-180 16 11.25)",
    fill: "#0A7E85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21L15 15C15 14.4477 15.4477 14 16 14C16.5523 14 17 14.4477 17 15V21Z",
    fill: "#0A7E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32CircleInfo);
export default __webpack_public_path__ + "static/media/icon32_circle_info.372b0f4a72d2717012db1fd815ecc5ca.svg";
export { ForwardRef as ReactComponent };